import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "recommended-video-v2-widget"
}
const _hoisted_2 = { class: "recommended-video-v2-widget__container" }
const _hoisted_3 = { class: "recommended-video-v2-widget__img" }
const _hoisted_4 = { class: "recommended-video-v2-widget__title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "recommended-video-v2-widget__label" }, " Videóajánló: ", -1)
const _hoisted_6 = { class: "recommended-video-v2-widget__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Play = _resolveComponent("Play")!
  const _component_Image = _resolveComponent("Image")!
  const _component_nav_link = _resolveComponent("nav-link")!
  const _component_Close = _resolveComponent("Close")!

  return (_ctx.show && _ctx.content)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_nav_link, {
            class: "recommended-video-v2-widget__content",
            to: `${_ctx.content.url}?autoplay=true&source=cikkoldali_videoajanlo&medium=${_ctx.content.title.replace(/ /g, '_')}&campaign=v2`,
            onClickCapture: _cache[0] || (_cache[0] = ($event: any) => (_ctx.measure('select')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Play, { class: "recommended-video-v2-widget__icon" }),
                _createVNode(_component_Image, {
                  "image-url": _ctx.content.leadImageUrls?.leadImageUrl169,
                  alt: _ctx.content.title,
                  dimensions: false
                }, null, 8, ["image-url", "alt"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("span", null, _toDisplayString(_ctx.content.title), 1)
              ])
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "recommended-video-v2-widget__close-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
            }, [
              _createVNode(_component_Close)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}